export default __webpack_public_path__ + "static/media/d31.f893fdfe.png";